export enum ExpeditionPickupSelectedByEnum {
  CLIENT = "CLIENT",
  DRIVER = "DRIVER",
  SYSTEM = "SYSTEM",
}
